import Vue from 'vue'

import dateHelpers from '@/helpers/date-helpers'
import commonHelpers from '@/helpers/common-helpers'
import apiErrors from '@/helpers/api-errors'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  install: () => {
    Vue.prototype.dateHelpers = dateHelpers
    Vue.dateHelpers = dateHelpers

    Vue.prototype.commonHelpers = commonHelpers
    Vue.commonHelpers = commonHelpers

    Vue.prototype.apiErrors = apiErrors
    Vue.apiErrors = apiErrors
    apiErrors.setToastHandler(props => Vue.$toast({ component: ToastificationContent, props }, { position: 'top-center' }))
  },
}
